import React, { FC } from 'react';

import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { useFeatureLoyaltyUi } from 'hooks/use-feature-loyalty-ui';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import {
  DetailsButton,
  LearnMoreButton,
  LearnMoreIcon,
  StyledLoyaltyRewardsLogo,
  TextContainer,
  UnauthenticatedContainer,
  WelcomeMessage,
} from './styled';

const UnauthenticatedBanner: FC = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { featureLoyaltyUiLoading, featureLoyaltyUi } = useFeatureLoyaltyUi();
  const hasIcon = !featureLoyaltyUiLoading && featureLoyaltyUi?.rewardsLearnMoreIcon?.locale;
  const ButtonComponent = hasIcon ? LearnMoreButton : DetailsButton;
  const hideLoyaltyBannerWelcomeMessage = useFlag(
    LaunchDarklyFlag.ENABLE_HIDE_LOYALTY_BANNER_WELCOME_MESSAGE
  );

  const handleClick = () => {
    navigate(formatMessage({ id: 'routes.loyaltyBannerUnauthenticated' }));
  };

  return (
    <UnauthenticatedContainer
      center={hideLoyaltyBannerWelcomeMessage}
      data-testid="unauthenticated-banner"
    >
      <TextContainer>
        <StyledLoyaltyRewardsLogo />
        {!hideLoyaltyBannerWelcomeMessage && (
          <WelcomeMessage>{formatMessage({ id: 'loyaltyBannerLoggedOutMessage' })}</WelcomeMessage>
        )}
      </TextContainer>
      <ButtonComponent
        size={ActionButtonSizes.SMALL}
        data-testid="unauthenticated-banner-learn-more"
        variant={ActionButtonVariants.OUTLINE}
        onClick={handleClick}
      >
        {hasIcon && (
          <LearnMoreIcon
            image={featureLoyaltyUi?.rewardsLearnMoreIcon?.locale}
            alt=""
            objectFitContain
          />
        )}
        {formatMessage({ id: 'loyaltyBannerDetailsButtonLabel' })}
      </ButtonComponent>
    </UnauthenticatedContainer>
  );
};

export default UnauthenticatedBanner;
